import type { RankingOrder, RankingResultCount, RankingTimeframe } from "../../../../types/callRanking";
import { ALL_AGENTS } from "../../../../types/callRanking";

interface BuildExploreUrlParams {
  order: RankingOrder;
  lens: string;
  attribute?: string;
  timeframe: RankingTimeframe;
  agent?: string;
  resultCount: RankingResultCount;
}

export const buildExploreUrl = ({
  order,
  lens,
  attribute,
  timeframe,
  agent,
  resultCount
}: BuildExploreUrlParams): string => {
  const params = new URLSearchParams();

  params.set("ranking_order", order);
  params.set("sc_name", lens);
  params.set("time_range", timeframe);
  params.set("ranking_count", String(resultCount));

  if (attribute) {
    params.set("ranking_attribute", attribute);
  }

  if (agent && agent !== ALL_AGENTS) {
    params.set("user_email", agent);
  }

  return `/explore?${params.toString()}`;
};
